var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CourseList',{attrs:{"level-key":"intermediateLevel","fetch-action":"getCourseIntermediates","getter-name":"courseIntermediates"}})
}
var staticRenderFns = []

export { render, staticRenderFns }